export default __webpack_public_path__ + "static/media/contact3M.b3d70e18.webp";